module.exports = __webpack_public_path__ + "img/tap.b7f4103d.svg";